// React
import React, {Component} from "react";

export class Lang extends Component {
    render() {
        const {text} = this.props;
        return (
            <div className={"dashboard_element lang"}>
                <span>{text}</span>
            </div>
        );
    }
}
